import { buttons } from './order_food_contants';
import OrderNowButton from './order_food_button';

const OrderFoodButtons = () => {
    return (
        <div className="order-food-buttons-inline-container">
            {buttons.map((button, index) => (
                <OrderNowButton
                    key={index}
                    link={button.link}
                    label={button.buttonTitle}
                    buttonClass={button.buttonClass}
                    containerClass={button.containerClass}
                    linkClass={button.linkClass}
                    icon={button.icon}
                    disabled={button.disabled}
                />
            ))}
        </div>
    );
}
export default OrderFoodButtons;